import { AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { CalendarOptions, DateSelectArg, DatesSetArg, EventApi, EventClickArg, EventInput } from '@fullcalendar/core'; // useful for typechecking
import dayGridPlugin from '@fullcalendar/daygrid';
import { Calendar } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import bootstrapPlugin from '@fullcalendar/bootstrap';
import { CalendarService } from 'src/app/services/calendar.service';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { DatePipe } from '@angular/common';
import { OptionSet } from 'src/app/models/OptionSet';
import { ScheduleTime, Vacation } from 'src/app/models/CalendarModels';
import { Schedule_ep } from 'src/app/models/Schedule_ep';
import { HebrewCalendar, HDate, Location, Event } from '@hebcal/core';
import { disableDebugTools } from '@angular/platform-browser';


@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit, AfterViewInit {
  @Output() onSelectDay: EventEmitter<any[]> = new EventEmitter<any[]>();
  selectedDays: any[] = [];
  holidaysList: Vacation[] = [];
  daysList: ScheduleTime[] = [];
  classDaysList: ScheduleTime[] = [];
  classVacationsList: Vacation[] = [];
  holidays: EventInput[] = [];
  days: EventInput[] = [];
  classDays: EventInput[] = [];
  classVacations: EventInput[] = [];
  lastClickedDate: Date | null = null;
  calendarOptions: CalendarOptions = {

    initialView: 'dayGridMonth',
    plugins: [dayGridPlugin, bootstrapPlugin, interactionPlugin,],
    locale: 'he',
    direction: 'rtl',
    dayMaxEvents: true,
    fixedWeekCount: false,
    showNonCurrentDates: false,
    moreLinkContent: (value) => { return "עוד " + value.num + "..."; },
    headerToolbar: { center: "title", left: "prev,next", right: "" },
    height: 647,
    customButtons: {
      prev: {
        click: this.getEventsByMonthBefore.bind(this),
      }, next: { click: this.getEventsByMonthAfter.bind(this) }
    },
    eventOrder: ['description'],
    events: (info, funcSucs, funcFail) => {
      const month = info.end.getMonth();
      const year = info.end.getFullYear();
      this.getHebrewDates(month, year);
    },
    // selectable: true,
    // select: this.handleDateSelect.bind(this),
    // eventClick: this.handleDateClick.bind(this),
    // eventsSet: this.handleEvents.bind(this),
    dateClick: this.handleDateClick.bind(this),
  };


  @ViewChild('calendar', { static: false }) fullcalendar: FullCalendarComponent;
  @Output() selectDayEvent = new EventEmitter<any>();
  calendarApi: Calendar;

  constructor(private calendarSvc: CalendarService) {
    this.calendarSvc.accountScheduleSubject.subscribe(() => {
      this.loadVacationsData();
      this.setScheduleHoursInMonth();
      // if (this.calendarSvc.accountSchedule.Id_p) {
        
        
      // }
      // else {
      //   this.calendarSvc.spinnerSubjectEmit(false);
      // }
    });

    this.calendarSvc.classScheduleSubject.subscribe(() => {
      this.setClassesScheduleHoursInMonth();
      this.renderCalendarEventResources();
    });

    this.calendarSvc.classVacationSubject.subscribe(() => {
      this.setClassesVacationsInMonth();
      this.renderCalendarEventResources();
    });
  }
  ngAfterViewInit(): void {
    this.calendarApi = this.fullcalendar.getApi();
    this.renderCalendarEventResources();
  }

  getHebrewDates(month: number, year: number) {
    const currMonth = month.toString().padStart(2, "0");
    const nextMonth = (month + 1).toString().padStart(2, "0");
    const start = `${year}-${currMonth}-01`;

    const end = `${year}-${nextMonth}-01`;
    //setTimeout(()=>this.resetTitle(new Date(start)),100)

    const url = `https://www.hebcal.com/converter?cfg=json&start=${start}&end=${end}&g2h=1`;
    fetch(url, { method: 'GET' })
      .then(response => response.json())
      .then(data => {
        const date = new Date(data.start);
        const month = date.toLocaleString('he', { month: 'long' });
        console.log(year, month);
        this.addHebewDates(data, date.getFullYear(), month);
      }).catch(err => {
        console.log(err);
      });

  }

  addHebewDates(dates: any[], year: number, month: string) {
    const dayDivs = document.getElementsByClassName("fc-daygrid-day");
    for (let i = 0; i < dayDivs.length; i++) {
      const dayDiv = dayDivs.item(i);
      const dayHeader = dayDiv.firstElementChild.firstElementChild;
      if (!dayHeader.querySelector(".hebrewDate")) {
      const newElement = document.createElement("a");
      newElement.classList.add("hebrewDate");
      //console.log(dayDiv["dataset"]["date"]);
      let date = dates["hdates"][dayDiv["dataset"]["date"]]?.heDateParts.d;
      if (date != undefined) {
        newElement.innerText = date;
        dayHeader.append(newElement);
      }
    }
   }
    const firstMonth = dates["hdates"][dates["start"]]?.heDateParts.m;
    const lastMonth = dates["hdates"][dates["end"]]?.heDateParts.m;

    const gregorianMonthHeader1 = document.getElementsByClassName("fc-toolbar-title")[0];
    const gregorianMonthHeader2 = gregorianMonthHeader1;
    gregorianMonthHeader2.innerHTML = `${month} ${year} (${firstMonth} - ${lastMonth})`;
    document.getElementsByClassName("fc-header-toolbar")[0].childNodes[1].replaceChild(gregorianMonthHeader2, gregorianMonthHeader1)
  }

  resetTitle(date: Date) {

    const month = date.toLocaleString('he', { month: 'long' });;
    const year = date.getFullYear();
    const gregorianMonthHeader1 = document.getElementsByClassName("fc-toolbar-title")[0];

    const gregorianMonthHeader2 = gregorianMonthHeader1;
    console.log(gregorianMonthHeader1, gregorianMonthHeader2)
    gregorianMonthHeader2.innerHTML = `${month} ${year}`;
    document.getElementsByClassName("fc-header-toolbar")[0].childNodes[1].replaceChild(gregorianMonthHeader2, gregorianMonthHeader1)
  }

  ngOnInit() {
  }

  loadVacationsData() {
    this.calendarSvc.spinnerSubjectEmit(true);
    let date = this.calendarSvc.transformDate(this.calendarApi.getDate(), 'yyyy-MM-dd');
    this.calendarSvc.getVacationsForAccount(date).then((res: any) => {
      if (!this.calendarSvc.dataService.IsError(res)) {
        this.calendarSvc.vacations = JSON.parse(res);
        this.holidaysList = [];
        var currentDate = this.calendarApi.getDate();
        var lastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        for (let i = 1; i <= lastDate.getDate(); i++) {
          try {
            let date = new Date(currentDate.getFullYear(), currentDate.getMonth(), i);
            let dateStr = this.calendarSvc.transformDate(date, 'yyyy-MM-dd');
            let vacationObj = this.calendarSvc.vacations?.find(x =>
              dateStr >= x.Date && dateStr <= x.DateTo
            );
            let indexDay = this.daysList.findIndex(x => x.date == dateStr);
            let v: Vacation = null;
            if (vacationObj) {
              v = {
                VacationForAccountId: vacationObj.VacationForAccountId,
                Name: vacationObj.Period.viewValue,
                Date: dateStr,
                //Color: vacationObj.Color ? this.calendarSvc.ColorsList.find(c => c.value == vacationObj.Color.value) : this.calendarSvc.ColorsList[Math.floor(Math.random() * this.calendarSvc.ColorsList.length)],
                Color: vacationObj.IsShortDay ? 'purple' : 'orange',
                IsShortDay: vacationObj.IsShortDay,
                EndTime: vacationObj.EndTime,
                Sector: vacationObj.Sector,
              };
              if (v.IsShortDay && v.EndTime) {
                if (indexDay > -1) {
                  this.daysList[indexDay].hour = v.EndTime.viewValue;
                } else {
                  this.daysList.push({ date: this.calendarSvc.transformDate(date, 'yyyy-MM-dd'), hour: v.EndTime.viewValue });
                }
              }
              else {
                if (indexDay > -1) {
                  this.daysList.splice(indexDay, 1);
                }
              }
            } else {
              if (indexDay > -1) {
                v = { Name: "לימודים כרגיל", Date: dateStr, };
              }

            }
            if (v) {
              this.holidaysList.push(v);
            }

          } catch (err) {
            debugger
          }
        }
        this.renderCalendarEventResources();
      }
      this.calendarSvc.spinnerSubjectEmit(false);
    }, (err) => {
      debugger
    });
  }


  renderCalendarEventResources() {
    this.calendarApi.render();
    this.calendarApi.removeAllEventSources();
    this.holidays = this.holidaysList.map(x => {
      let h: EventInput =
      {
        id: x.VacationForAccountId,
        title: x.Name,
        date: x.Date,
        color: x.Color ? x.Color : 'default',
        description: 'a',
        classNames: ['textCenter'],
        groupId: x.VacationForAccountId ? '1' : '0'
      }
      return h;
    });
    this.days = this.daysList.map(x => {
      let d: EventInput = {
        title: x.hour,
        date: x.date,
        color: 'white',
        className: 'textCenter',
        textColor: 'black',
        description: 'b',
        backgroundColor: 'transparent',
        groupId: '0'
      }
      return d;
    });
    this.classDays = this.classDaysList.map(x => {
      let cd: EventInput =
      {
        // id: x.Id_p,
        title: x.title + " " + x.hour,
        date: x.date,
        color: 'white',
        className: 'textCenter',
        textColor: '#007bff',
        backgroundColor: 'transparent',
        description: 'c',
        classNames: ['textCenter'],
        groupId: '0'
      }
      return cd;
    });
    this.classVacations = this.classVacationsList.map(x => {
      let cv: EventInput =
      {
        title: x.Name + " " + x.EndTime.viewValue,
        date: x.Date,
        color: 'white',
        textColor: x.Color ? x.Color : 'default',
        backgroundColor: 'transparent',
        description: 'd',
        classNames: ['textCenter'],
        groupId: '0'
      }
      return cv;
    });
    if (this.holidays.length > 0) {
      this.calendarApi.addEventSource(this.holidays);
      this.calendarApi.addEventSource(this.days);
      this.calendarApi.addEventSource(this.classDays);
      this.calendarApi.addEventSource(this.classVacations);
      this.calendarApi.render();
    }
  }

  getEventsByMonthBefore() {
    this.calendarApi.prev();
    this.getHebrewDates(this.calendarApi.getDate().getMonth() + 1, this.calendarApi.getDate().getFullYear())
    this.setScheduleHoursInMonth();
    this.setClassesScheduleHoursInMonth();
    this.loadVacationsData();
    this.calendarSvc.getVacationsForClasses();
    this.clearBackgroundDatesToUnselected();
  }

  getEventsByMonthAfter() {
    this.calendarApi.next();
    this.getHebrewDates(this.calendarApi.getDate().getMonth() + 1, this.calendarApi.getDate().getFullYear())
    this.setScheduleHoursInMonth();
    this.setClassesScheduleHoursInMonth();
    this.loadVacationsData();
    this.calendarSvc.getVacationsForClasses();
    this.clearBackgroundDatesToUnselected();
  }

  // fillHebrewDates(){
  //   const info = this.calendarApi.getDate();
  //   const days = info.start.getDate();
  //   const daye = info.end.getDate();
  //   const months = info.start.getMonth() + 1;
  //   const monthe = info.end.getMonth() + 1;
  //   const years = info.start.getFullYear();
  //   const yeare = info.end.getFullYear();
  //   const start =  years+"-"+months.toString().padStart(2,"0")+"-"+days.toString().padStart(2,"0");
  //   const end =  yeare+"-"+monthe.toString().padStart(2,"0")+"-"+daye.toString().padStart(2,"0");
  //   const url = "https://www.hebcal.com/converter?cfg=json&start=" +  start + "&end=" + end +"&g2h=1";
  //   //console.log(url);
  //   fetch(url, {method: 'GET'})
  //   .then(response => response.json())
  //   .then(data => {debugger;
  //     this.addHebewDates(data);
  //     // const parsableData =  data.map(eventEl => {
  //     //     return {
  //     //       title: eventEl.title,
  //     //       date: eventEl.start,
  //     //       allDay: true
  //     //     }
  //     //   });
  //     // console.log(parsableData);
  //     // successCallback(parsableData)
  //   }).catch(err => {
  //     console.log(err);
  //   });
  // }

  setScheduleHoursInMonth() {
    this.daysList = [];
    var currentDate = this.calendarApi.getDate();
    var lastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    for (let i = 1; i <= lastDate.getDate(); i++) {
      let date = new Date(currentDate.getFullYear(), currentDate.getMonth(), i);
      let hour = this.getHourByDay(this.calendarSvc.accountSchedule, date.getDay());
      if (hour != null) {
        let day: ScheduleTime = { date: this.calendarSvc.transformDate(date, 'yyyy-MM-dd'), hour: hour };
        this.daysList.push(day);
      }
    }
  }

  setClassesScheduleHoursInMonth() {
    this.classDaysList = [];
    var currentDate = this.calendarApi.getDate();
    var lastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    this.calendarSvc.classSchedulesList.forEach((item) => {
      for (let i = 1; i <= lastDate.getDate(); i++) {
        let date = new Date(currentDate.getFullYear(), currentDate.getMonth(), i);
        let hour = this.getHourByDay(item, date.getDay());
        if (hour != null) {
          let day: ScheduleTime = {
            date: this.calendarSvc.transformDate(date, 'yyyy-MM-dd'), hour: hour
            , title: item.Class.viewValue
          };
          if ((item.ClassCode)) {
            day.title += item.ClassCode.viewValue;
          }
          this.classDaysList.push(day);
        }
      }
    });
  }

  setClassesVacationsInMonth() {
    this.classVacationsList = [];
    var currentDate = this.calendarApi.getDate();
    var lastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    for (let i = 1; i <= lastDate.getDate(); i++) {
      try {
        let date = new Date(currentDate.getFullYear(), currentDate.getMonth(), i);
        let dateStr = this.calendarSvc.transformDate(date, 'yyyy-MM-dd');
        let vacationObjList = this.calendarSvc.classVacsationsList ? this.calendarSvc.classVacsationsList.filter(x => x.Dates.includes(dateStr)) : null;
        vacationObjList.forEach(vacationObj => {
          let v: Vacation = null;
          if (vacationObj && vacationObj.IsShortDay && vacationObj.EndTime) {
            let v: Vacation = {
              VacationForAccountId: vacationObj.VacationForAccountId,
              //Name: vacationObj.Name,
              Name: vacationObj.Class ? vacationObj.Class.viewValue : vacationObj.Name,
              Date: dateStr,
              Color: vacationObj.IsShortDay ? 'purple' : 'orange',
              IsShortDay: vacationObj.IsShortDay,
              EndTime: vacationObj.EndTime,
              Sector: vacationObj.Sector,
              Description: vacationObj.Description
            };
            if (v.IsShortDay && v.EndTime) {
              if (vacationObj.ClassCode) {
                v.Name += vacationObj.ClassCode.viewValue
              }
              this.classVacationsList.push(v);
            }
          }
        });
      } catch (err) {
        debugger
      }
    }
  }

  // setDayEvent(date: Date): EventInput {

  //   let hour = this.getHourByDay(date.getDay());
  //   if (hour != null) {
  //     let newDayEvent: EventInput = {
  //       // id: 'd',
  //       title: hour,//'13:00',
  //       date: this.calendarSvc.transformDate(date, 'yyyy-MM-dd'),
  //       color: 'white',
  //       className: 'textCenter',
  //       textColor: 'black',
  //     };
  //     return newDayEvent;
  //   }
  // }

  handleDateClick(dateEvent: any) {
    const clickedDate = dateEvent.date;
    const dayElement = dateEvent.dayEl;
    const isShiftPressed = dateEvent.jsEvent.shiftKey;
  
    if (isShiftPressed && this.lastClickedDate) {
      this.selectedDays = []; 
  
      const startDate = this.lastClickedDate < clickedDate ? this.lastClickedDate : clickedDate;
      const endDate = this.lastClickedDate > clickedDate ? this.lastClickedDate : clickedDate;
  
      let current = new Date(startDate);
      while (current <= endDate) {
        this.selectedDays.push({
          str: this.calendarSvc.transformDate(current, 'dd/MM'),
          date: new Date(current)
        });
  
        current.setDate(current.getDate() + 1);
      }
    } else {
      const index = this.selectedDays.findIndex(x => x.date.getTime() === clickedDate.getTime());
      if (index !== -1) {
        this.selectedDays.splice(index, 1);
        dayElement.style.backgroundColor = '';
      } else {
        this.selectedDays.push({
          str: this.calendarSvc.transformDate(clickedDate, 'dd/MM'),
          date: clickedDate
        });
        dayElement.style.backgroundColor = 'rgba(195, 236, 247)';
      }
  
      this.lastClickedDate = clickedDate;
    }
  
    this.onSelectDay.emit(this.selectedDays);
    this.clearBackgroundDatesToUnselected();
  }
  // handleDateSelect(selectInfo: DateSelectArg) {
  //   debugger
  //   const title = prompt('Please enter a new title for your event');
  //   const calendarApi = selectInfo.view.calendar;
  // }

  // handleEventClick(clickInfo: EventClickArg) {
  //   debugger
  //   clickInfo.event.setProp("backgroundColor", "#ffdd99")
  // }

  handleEvents(events: EventApi[]) {
  }

  // clearBackgroundDatesToUnselected() {
  //   debugger;
  //   let templateDate = this.calendarSvc.transformDate(this.calendarApi.getDate(), "yyyy-MM-");
  //   var days = this.calendarApi.el.getElementsByTagName('td');
  //   for (let index = 1; index < days.length; index++) {
  //     let date = templateDate + index.toString().padStart(2, "0");
  //     let item = this.selectedDays.find(x => this.calendarSvc.transformDate(x.date, 'yyyy-MM-dd') == date)
  //     if (item && days[index].getAttribute('data-date')) {
  //       days[index].style.backgroundColor = 'rgba(188,232,241,.3)';
  //     } else {
  //       days[index].style.backgroundColor = '';
  //     }
  //   }
  // }

  clearBackgroundDatesToUnselected() {
    let templateDate = this.calendarSvc.transformDate(this.calendarApi.getDate(), "yyyy-MM-");
    this.calendarApi.el.querySelectorAll('td').forEach((day: any, index) => {
      var dataDate = day.getAttribute('data-date');
      let item = null;
      if (dataDate) {
        item = this.selectedDays.find(x => this.calendarSvc.transformDate(x.date, 'yyyy-MM-dd') == dataDate)
      }
      if (dataDate && item) {
        day.style.backgroundColor = 'rgba(188,232,241,.3)';
      } else {
        day.style.backgroundColor = '';
      }
    });
  }


  getHourByDay(schedule: Schedule_ep, day: number): string {
    let value: string;
    switch (day) {
      case 0:
        //value = this.calendarSvc.accountSchedule.Sunday_p ? this.calendarSvc.accountSchedule.Sunday_p.viewValue : null;
        value = schedule.Sunday_p?.viewValue;
        break;
      case 1:
        //value = this.calendarSvc.accountSchedule.Monday_p ? this.calendarSvc.accountSchedule.Monday_p.viewValue : null;
        value = schedule.Monday_p?.viewValue;
        break;
      case 2:
        //value = this.calendarSvc.accountSchedule.Tuesday_p ? this.calendarSvc.accountSchedule.Tuesday_p.viewValue : null;
        value = schedule.Tuesday_p?.viewValue;
        break;
      case 3:
        // value = this.calendarSvc.accountSchedule.Wednesday_p ? this.calendarSvc.accountSchedule.Wednesday_p.viewValue : null;
        value = schedule.Wednesday_p?.viewValue;
        break;
      case 4:
        // value = this.calendarSvc.accountSchedule.Thursday_p ? this.calendarSvc.accountSchedule.Thursday_p.viewValue : null;
        value = schedule.Thursday_p?.viewValue;
        break;
      case 5:
        // value = this.calendarSvc.accountSchedule.Friday_p ? this.calendarSvc.accountSchedule.Friday_p.viewValue : null;
        value = schedule.Friday_p?.viewValue;
        break;
      case 6:
        // value = this.calendarSvc.accountSchedule.Saturday_p ? this.calendarSvc.accountSchedule.Saturday_p.viewValue : null;
        value = schedule.Saturday_p?.viewValue;
        break;
      default:
        value = null;
        break;
    }
    return value;
  }


}



